export const PLUGIN_MODULE_PERMISSIONS = {
	administration: {
		user: {
			core_plugin_administration_user_list: false,
			core_plugin_administration_user_create: false,
			core_plugin_administration_user_edit: false,
			core_plugin_administration_user_delete: false
		},
		role: {
			core_plugin_administration_role_list: false,
			core_plugin_administration_role_create: false,
			core_plugin_administration_role_edit: false,
			core_plugin_administration_role_delete: false
		},
		default_dashboard: {
			core_plugin_administration_default_dashboard_list: false,
			core_plugin_administration_default_dashboard_edit: false,
			core_plugin_administration_default_dashboard_delete: false
		},
		provider: {
			core_plugin_administration_provider_list: false,
			core_plugin_administration_provider_create: false,
			core_plugin_administration_provider_edit: false,
			core_plugin_administration_provider_delete: false
		},
		plugin: {
			core_plugin_administration_plugin_list: false,
			core_plugin_administration_plugin_edit: false
		},
		public_view: {
			core_plugin_administration_public_view: false
		},
		global_settings: {
			core_plugin_administration_global_settings_view: false
		}
	},
	user_profile: {
		core_plugin_user_profile_enabled: false
	},
	user_preferences: {
		core_plugin_user_preferences_enabled: false
	},
	dashboard: {
		default_dashboard: {
			core_plugin_dashboard_default_dashboard_list: false,
			core_plugin_dashboard_default_dashboard_create: false,
			core_plugin_dashboard_default_dashboard_edit: false,
			core_plugin_dashboard_default_dashboard_delete: false
		},
		custom_dashboard: {
			core_plugin_dashboard_custom_dashboard_list: false,
			core_plugin_dashboard_custom_dashboard_create: false,
			core_plugin_dashboard_custom_dashboard_edit: false,
			core_plugin_dashboard_custom_dashboard_delete: false
		}
	},
	widget: {
		core_plugin_widget_dashboard_edit: false
	},
	menuitem: {
		core_plugin_menuitem_dashboard_edit: false
	},
};
